export interface VirtualBackground {
  src: string
  type?: 'blur' | 'image'
  blurAmount?: number
  label?: string
}

export const VIRTUAL_BACKGROUNDS: VirtualBackground[] = [
  {
    src: 'system-blur',
    type: 'blur',
    blurAmount: 10,
    label: 'No Background',
  },
  {
    src: '/images/virtual-backgrounds/1.png',
    type: 'image',
  },
  {
    src: '/images/virtual-backgrounds/2.png',
    type: 'image',
  },
  {
    src: '/images/virtual-backgrounds/3.png',
    type: 'image',
  },
  {
    src: '/images/virtual-backgrounds/4.png',
    type: 'image',
  },
  // add more src backgrounds here
]

export const VIRTUAL_BACKGROUND_DEFAULT = VIRTUAL_BACKGROUNDS[0] as VirtualBackground
